"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

/** Silently logs 404 hits to /api/seo/not-found for the admin SEO dashboard. */
export function NotFoundLogger() {
  const pathname = usePathname();
  useEffect(() => {
    fetch("/api/seo/not-found", {
      method: "POST",
      body: JSON.stringify({ path: pathname, referrer: document.referrer }),
      headers: { "content-type": "application/json", "x-internal": "1" },
    }).catch(() => {});
  }, [pathname]);
  return null;
}
